import { render } from "./WordGroupForm.vue?vue&type=template&id=2d66b9c1"
import script from "./WordGroupForm.vue?vue&type=script&lang=js"
export * from "./WordGroupForm.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/gilcode.com/kwordz.gilcode.com/packages/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__